var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-612.000000, -14.000000)",
    fill: "#495057"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M623.8,24.2 L627.8,28.2 C628.2,28.6 628.2,29.2 627.8,29.6 C627.4,30 626.8,30 626.4,29.6 L622.4,25.6 C621.4,26.3 620.2,26.8 619,26.8 C615.7,26.8 613,24.1 613,20.8 C613,17.5 615.7,14.8 619,14.8 C622.3,14.8 625,17.5 625,20.8 C625,22 624.5,23.2 623.8,24.2 Z M619,25 C621.2,25 623,23.2 623,21 C623,18.8 621.2,17 619,17 C616.8,17 615,18.8 615,21 C615,23.2 616.8,25 619,25 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ef3c70f1e9d7cbb47c0b786bffa3e97e.svg";
export { ForwardRef as ReactComponent };